import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {Typography, Box, Stack, screenSizeSmaller} from 'views/components';
import {AccessTime as AccessTimeIcon} from 'views/icons';
import {useNavigate, getEventStatusStyles} from 'views/module';

import EventHoverDetails from './EventHoverDetails';

import moment from 'moment-timezone';

const EventTile = (props) => {
  const {event} = props;
  const detailPath = props.detailPath || '/schedule/event';

  const navigate = useNavigate();

  const [isHovered, setIsHovered] = useState(false);

  const startTimeMoment = moment.tz(event.eventData.startTime, event.eventData.timezone);

  const startTime = startTimeMoment.format('hh:mmA');

  const isScreenSmaller = screenSizeSmaller('xxl');

  const styles = getEventStatusStyles({event});

  return (
    <Box
      sx={{
        background: styles.background,
        borderRadius: 1,
        p: 1,
        pb: 0.5,
        mb: 0.5,
        boxShadow: 1,
        borderLeft: `3px solid ${styles.borderColor}`,
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={(e) => {
        if (e.ctrlKey || e.metaKey) {
          window.open(`${detailPath}/${event.eventRn}`, '_blank');
          return;
        }
        navigate(`${detailPath}/${event.eventRn}`);
      }}
      onAuxClick={(e) => {
        if (e.button === 1) {
          window.open(`${detailPath}/${event.eventRn}`, '_blank');
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: 'block',
          fontWeight: 'medium',
          color: styles.textColor,
          textDecoration: styles.isInactive ? 'line-through' : 'none',
        }}
      >
        {event.info.title}
      </Typography>
      <Stack
        direction='row'
        alignItems='center'
        spacing={1}
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <Box>
          <Typography
            variant="caption"
            sx={{
              opacity: 0.7,
              color: '#616161',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <AccessTimeIcon sx={{fontSize: '0.9rem', mr: 0.5}} />
            {startTime}
          </Typography>
        </Box>
        {
          (!isScreenSmaller || styles.isInactive) && styles.label && (
            <Box
              sx={{
                border: `1px solid ${styles.borderColor}`,
                borderRadius: 1,
                alignItems: 'center',
                height: 'fit-content',
                px: 0.5,
                py: 0.1,
                display: 'flex',
                lineHeight: 1,
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 'medium',
                  color: styles.textColor,
                  lineHeight: 1,
                }}
              >
                {styles.label}
              </Typography>
            </Box>
          )
        }
      </Stack>
      <EventHoverDetails
        event={event}
        styles={styles}
        isHovered={isHovered}
      />
    </Box>
  );
};

EventTile.propTypes = {
  event: PropTypes.object.isRequired,
  detailPath: PropTypes.string,
};

export default EventTile;
